import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerRange = ({
  dateRange,
  setDateRange,
  isOpen=false,
  handleOpen,
  disable=false,
}) => {
  const [startDate, endDate] = dateRange;

  const handleDateChange = (update) => {
    setDateRange(update);

    if (update[0] && update[1]) {
      handleOpen(false);
    }
  };

  const today = new Date();

  return (
    <DatePicker
      selectsRange={true}
      startDate={startDate}
      endDate={endDate}
      dateFormat="MM/dd/yyyy"
      isClearable={false}
      open={isOpen}
      disabled={disable}
      maxDate={today}
      onChange={(update) => handleDateChange(update)}
      onClickOutside={() => handleOpen(false)}
    />
  );
};

export default DatePickerRange;